import { render, staticRenderFns } from "./business-payment-table.vue?vue&type=template&id=77a7f4c8"
import script from "./business-payment-table.vue?vue&type=script&lang=js"
export * from "./business-payment-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports